import Immutable from 'immutable';
import { createMigration } from './utils';
import { TRANSITIONS_REVERSE } from './resources/lottieTransitionsReverse';

export const migrationTo9_172 = createMigration({
    migrateVideo(video) {
        return video.withMutations(map => {
            map.get('slides').forEach((scene, i) => {
                map.setIn(['slides', i], this.migrateScene(scene));
            });
        });
    },
    migrateScene(scene) {
        return scene.withMutations(map => {
            const customTransitionUrl = map.getIn(['customTransition', 'transitionUrl']) as string;
            let transition = 'None';
            let transitionDuration = 0;
            if (TRANSITIONS_REVERSE[customTransitionUrl]) {
                transition = TRANSITIONS_REVERSE[customTransitionUrl].transition;
                transitionDuration = TRANSITIONS_REVERSE[customTransitionUrl].duration;
            }

            // restore previous values
            map.set('transition', transition);
            map.set('transitionDuration', transitionDuration);

            // remove customTransition info
            map.set('customTransition', Immutable.Map());
        });
    },
});
